import { Injectable } from '@angular/core';
import { IResponseMeta, RequestService } from '@df/api/request/request.service';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { CheckoutService } from '@df/checkout/checkout.service';
import { App } from '@df/core/app';
import { Subscription } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
    providedIn: 'root'
})
export class CheckoutServiceDecorator extends CheckoutService {
    stepsChange = new Subject<Checkout.IStep[] | undefined>();

    availableShippingMethods: Checkout.IShippingMethod[] = [];

    availableShippingMethodsSubject = new Subject<Checkout.IShippingMethod[]>();

    private _steps?: Checkout.IStep[];

    protected requestSubscription?: Subscription;

    constructor(
        request: RequestService,
        protected app: App
    ) {
        super(request);

        this.requestSubscription = this.app.request.subscribe((requestData?: IResponseMeta) => {
            const result = requestData?.result;

            if (result) {
                if (result.checkout) {
                    this.onCheckoutUpdate(result.checkout);
                }
                if (result.checkoutPatch) {
                    this.onCheckoutUpdate(result.checkoutPatch);
                }
                if (result.checkoutPatchDirect) {
                    this.onCheckoutUpdate(result.checkoutPatchDirect);
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.requestSubscription?.unsubscribe();
    }

    protected onCheckoutUpdate(checkoutData: Checkout.IData): void {
        const shippingData = checkoutData?.shipping;

        if (shippingData) {
            const methods = shippingData.methods || [];
            if (JSON.stringify(this.availableShippingMethods) !== JSON.stringify(methods)) {
                this.availableShippingMethods = methods;
                this.availableShippingMethodsSubject.next(methods);
            }
        }
    }

    get steps(): Checkout.IStep[] | undefined {
        return this._steps;
    }

    set steps(value: Checkout.IStep[] | undefined) {
        this._steps = value;
        this.stepsChange.next(this.steps);
    }
}
